//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import EventCard from '@/components/events/card.vue';
import filterMixin from '@/mixins/filter';
import { isEmpty } from 'lodash';

export default {
  components: { EventCard },
  mixins: [filterMixin],
  data() {
    return {
      buzy: false,
      empty: false,
      filterNamespace: 'eventList',
    };
  },
  async fetch() {
    // При загрузке страницы (например, обновлён фильтр)
    // лимит и оффсет сбрасываются
    this.$store.commit('eventsList/RESTORE_LIST_OFFSET_AND_LIMIT');

    // Получение списка ивентов
    await this.getData({});
  },
  computed: {
    events() {
      return this.$store.state.eventsList.list;
    },
    offset() {
      return this.$store.state.eventsList.listOffset;
    },
    more() {
      return this.$store.state.eventsList.more;
    },
    limit() {
      return this.$store.state.eventsList.listLimit;
    },
  },
  // По-умолчанию fetch не срабатывает повторно при изменении
  // query на текущем роуте
  watch: {
    '$route.query': {
      async handler(payload) {
        if (isEmpty(payload)) {
          this.clear();
        }

        // При загрузке страницы (например, обновлён фильтр)
        // лимит и оффсет сбрасываются
        this.$store.commit('eventsList/RESTORE_LIST_OFFSET_AND_LIMIT');

        // Получение списка ивентов
        await this.getData({});
      },
      deep: true,
    },
  },
  methods: {
    onClickEvent(event) {
      // Отправить событие клика по ивенту
      const gtmEventData = {
        event: 'autoEvent',
        eventCategory: 'webinar_click',
        eventAction: 'list',
        schedule_event_name: event.name,
        schedule_event_id: event.id,
        schedule_event_slug: event.slug,
        schedule_event_type: event.type,

        // new - новый дизайн.
        // old - старый дизайн.
        schedule_event_list_type: 'new',
      };

      const email = this.$app.user?.email;
      const phone = this.$app.user?.profile?.phone;
      if (email) gtmEventData.user_email = email;
      if (phone) gtmEventData.user_phone = phone;

      const direction = this.$store.getters['eventsList/GET_DIRECTION_BY_ID'](
        event.directionId,
      );
      if (direction) {
        const directionName = direction.name;
        gtmEventData.schedule_event_direction = directionName;
      }

      this.$gtm?.push(gtmEventData);
    },
    /** У ивентов на странице отличаются размеры
     *  Первый - самый большой, на всю ширину страницы
     *  Четыре ивента со второго по пятый - средние, по 2 на строку
     *  Все остальные - маленькие, по 3 на строку
     */
    eventSizeByIndex(index) {
      if (index === 0) return 'large';
      else if (index <= 4) return 'medium';
      return 'small';
    },
    async getData({ push }) {
      this.buzy = true;

      const filterData = this.parsedFilter;
      await this.$store.dispatch('eventsList/SET_LIST', {
        filter: {
          ...filterData,
          limit: this.limit,
          offset: this.offset,
          published: true,
        },
        push,
      });

      if (!this.events.length) this.empty = true;
      else this.empty = false;
      this.buzy = false;
    },

    /** Запросить ещё ивентов по клику на Load More
     *  Параметр push отвечает за то, чтобы перед запросом
     *  список не опустошался
     */
    async getMore() {
      this.$store.commit('eventsList/INCREASE_LIST_OFFSET');
      await this.getData({ push: true });
    },
  },
};
